import Vue from 'vue'

import CContainer from './vue/container'
Vue.component('c-container', CContainer)

import CFa4 from './vue/fa4'
Vue.component('c-fa4', CFa4)
